// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookies-banner {
  position: fixed;
  width: 100%;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: var(--ce-grey-4);
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  color: black;
}

.cookies-banner.hidden {
  display: none;
}

.cookies-banner .cookies-banner-message {
  flex-grow: 1;
  padding: 10px 0 10px 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cookies-banner .cookies-banner-message a {
  padding-left: 4px;
  height: 44px;
  display: inline-flex;
  align-items: center;
}

.cookies-banner .hide-banner-icon-container {
  display: flex;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}

.cookies-banner a {
  text-decoration: underline;
}

@media (max-width: 767px) {
  .cookies-banner .cookies-banner-message {
    flex-direction: column;
  }
  .cookies-banner .cookies-banner-message a {
    padding-left: 0;
    position: relative;
    top: -5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/CookiesBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX;AACF","sourcesContent":[".cookies-banner {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  right: 0;\n  z-index: 999;\n  background: var(--ce-grey-4);\n  display: flex;\n  align-items: flex-start;\n  box-sizing: border-box;\n  color: black;\n}\n\n.cookies-banner.hidden {\n  display: none;\n}\n\n.cookies-banner .cookies-banner-message {\n  flex-grow: 1;\n  padding: 10px 0 10px 10px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cookies-banner .cookies-banner-message a {\n  padding-left: 4px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.cookies-banner .hide-banner-icon-container {\n  display: flex;\n  min-width: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.cookies-banner a {\n  text-decoration: underline;\n}\n\n@media (max-width: 767px) {\n  .cookies-banner .cookies-banner-message {\n    flex-direction: column;\n  }\n  .cookies-banner .cookies-banner-message a {\n    padding-left: 0;\n    position: relative;\n    top: -5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
